import { Component } from "react";
import Alert from "@/shared/components/Alert.jsx";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const message = this.state.error?.message || "Something went wrong. Please try again.";
    return (
      <div style={{ padding: 18, fontFamily: "'DM Sans', sans-serif" }}>
        <Alert type="error" message={message} />
      </div>
    );
  }
}
